{
  "auth.common.back_to_login": "返回登录",
  "auth.common.email": "邮箱",
  "auth.common.password_guidance": "至少 12 个字符，请使用仅自己知道的长密码。",
  "auth.forgot.cooldown": "如需再次申请，请在 {seconds} 秒后重试。",
  "auth.forgot.description": "输入登录邮箱。无论账号是否存在，我们都会显示相同结果。",
  "auth.forgot.error": "暂时无法提交找回请求，请稍后重试。",
  "auth.forgot.heading": "找回密码",
  "auth.forgot.submit": "发送重置指引",
  "auth.forgot.success": "请求已受理",
  "auth.forgot.success_description": "如账号存在，重置指引将通过已配置的安全渠道发送。",
  "auth.login.account": "账号",
  "auth.login.description": "使用你的组织账号安全访问管理控制台。",
  "auth.login.error.invalid": "账号或密码不正确",
  "auth.login.error.service": "暂时无法登录，请稍后重试",
  "auth.login.forgot": "忘记密码？",
  "auth.login.heading": "登录 AppKernia",
  "auth.login.password": "密码",
  "auth.login.register": "创建账号",
  "auth.login.register_prompt": "还没有账号？",
  "auth.login.security": "受保护的企业管理入口",
  "auth.login.submit": "登录",
  "auth.register.confirm_password": "确认密码",
  "auth.register.description": "注册账号并加入管理员配置的工作区。",
  "auth.register.display_name": "显示名称",
  "auth.register.error": "暂时无法创建账号，请稍后重试。",
  "auth.register.heading": "创建账号",
  "auth.register.mismatch": "两次输入的密码不一致。",
  "auth.register.password": "密码",
  "auth.register.submit": "创建账号",
  "auth.register.success": "注册请求已受理",
  "auth.register.success_description": "现在可以返回登录。为保护账号隐私，此页面不会说明邮箱是否已存在。",
  "auth.register.terms": "我已阅读并同意当前工作区的使用条款与隐私规则。",
  "auth.register.terms_required": "请先同意使用条款与隐私规则。",
  "auth.reset.confirm_password": "确认新密码",
  "auth.reset.description": "设置新密码后，账号的现有登录会话将全部撤销。",
  "auth.reset.error": "暂时无法重置密码，请稍后重试。",
  "auth.reset.heading": "重置密码",
  "auth.reset.invalid": "重置链接无效或已过期，请重新申请。",
  "auth.reset.mismatch": "两次输入的新密码不一致。",
  "auth.reset.new_password": "新密码",
  "auth.reset.submit": "重置密码",
  "auth.reset.success": "密码已重置",
  "auth.reset.success_description": "所有旧会话已撤销，请使用新密码登录。",
  "auth.unavailable.description": "此功能当前未启用，请联系管理员。"
}
